<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { annotationMixin } from '@/mixins/annotationMixin'

import PlotlyLineChart from '@/components/plotly-chart/PlotlyLineChart.vue'

defineProps({ hoverItem: {} })

const store = useStore()

const { annotations } = annotationMixin(store)

const currentTopoProfile = computed(() => store.state.topoProfile.currentItem)
const currentItem = computed(() => store.state.reinforcementPoint.currentItem)

const topoSingleLine = computed(() => store.getters['topoProfilePoint/getPlotData'])
const soilLayerScatter = computed(() => store.getters['soilLayer/getPlotData'])
const reinforcementScatter = computed(() => store.getters['reinforcementPoint/getPlotData'])

const getChartYAxisRange = computed(() => (id) => {
  return store.getters['topoProfilePoint/getChartYAxisRange'](id)
})

const refPlot = 'reinforcement'


const currentItemAnnotation = computed(() =>
  currentItem.value
    ? {
        x: currentItem.value.geometry.coordinates[0],
        y: currentItem.value.geometry.coordinates[1],
        xref: 'x',
        yref: 'y',
        showarrow: true,
        arrowhead: 7,
        arrowsize: 1.25,
        arrowcolor: '#0186A7',
        ax: 0,
        ay: 10,
        hideToggle: false
      }
    : null
)

const reinforcementPlotData = computed(() => {
  const soilLayerPlotData = soilLayerScatter.value().map((data) => ({
    ...data,
    showlegend: false
  }))
  return [...soilLayerPlotData, ...topoSingleLine.value(), ...reinforcementScatter.value]
})
</script>
<template>
  <PlotlyLineChart
    v-if="currentTopoProfile"
    class="fill-height"
    :responsive="false"
    :data="reinforcementPlotData"
    :showAnimate="false"
    :annotations="[...annotations, currentItemAnnotation]"
    :refPlot="refPlot"
    :ref="refPlot"
    :hoverIds="[currentTopoProfile.id]"
    :yAxisRange="getChartYAxisRange(currentTopoProfile?.id)"
  ></PlotlyLineChart>
</template>
